import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services';
import { history } from 'store';
import {
  LOADING,
  ASYNC_CREATE_EVENT,
  ASYNC_EDIT_EVENT,
  ASYNC_CREATE_EVENT_EXTRA_MATERIAL,
  ASYNC_EDIT_EVENT_EXTRA_MATERIAL
} from 'store';

function* createEvent({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    const response = yield call(api.post, 'events', payload);
    yield call(history.push, `/events/edit/${response.data.id}`);
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* createEventExtraMaterial({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.post, 'extra-materials', payload);
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editEventExtraMaterial({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield payload.append('_method', 'PUT');
    yield call(api.post, `extra-materials/${payload.get('id')}`, payload);
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editEvent({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield payload.append('_method', 'PUT');
    yield call(api.post, `events/${payload.get('id')}`, payload);
    yield call(history.push, '/events');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

export default function* root() {
  yield all([
    takeLatest(ASYNC_CREATE_EVENT, createEvent),
    takeLatest(ASYNC_EDIT_EVENT, editEvent),
    takeLatest(ASYNC_CREATE_EVENT_EXTRA_MATERIAL, createEventExtraMaterial),
    takeLatest(ASYNC_EDIT_EVENT_EXTRA_MATERIAL, editEventExtraMaterial)
  ]);
}
